<template>
  <div>
    <el-dialog
      :before-close="handleClose"
      :visible.sync="dialogVisibleHuiGao"
      center
      class="huigaodialogdiv"
      width="1000px"
    >
      <div class="lineHeight">
        <img class="imgtop" src="../../assets/huigao.png" alt="" />
        <span class="blueColorText">回告留言</span>
        <el-divider class="bottonLine"></el-divider>
      </div>
      <div class="lianxidiv">
        <div class="flexdiv">
          <span class="labeltext">联系人:</span
          ><span>{{
            dialogInfo
              ? dialogInfo.publicationName
                ? dialogInfo.publicationName
                : dialogInfo.pressName
              : ''
          }}</span>
        </div>
      </div>
      <div class="huigaodiv">
        <p class="historyHuigao">历史回告:</p>
        <div>
          <ul class="listul" ref="divDom">
            <li class="chatli" :key="index" v-for="(item, index) in chatArr">
              <div v-if="item.type == '2'">
                <p class="chatTime">{{ item.createTime }}</p>
                <div>
                  <span
                    class="chatName"
                    v-bind:class="{
                      even: item.type == 2,
                      odd: item.type == 1,
                    }"
                    >{{
                      item.type == 2 ? '出版社：' : '：'+item.teacherName 
                    }}</span
                  >
                  <p class="chatContent">
                    {{ item.content }}
                  </p>
                </div>
              </div>
              <div class="rightchat" v-if="item.type == '1'">
                <p class="chatTime">{{ item.createTime }}</p>
                <div>
                  
                  <p class="chatContent">
                    {{ item.content }}
                  </p>
                  <span
                    class="chatName"
                    v-bind:class="{
                      even: item.type == 2,
                      odd: item.type == 1,
                    }"
                    >{{
                      item.type == 2 ? '出版社：' : '：'+item.teacherName 
                    }}</span
                  >
                </div>
              </div>
            </li>
            
          </ul>
        </div>
      </div>
      <div class="huigaodiv">
        <p class="historyHuigao">发送回告:</p>
        <el-input
          class="textareacss"
          type="textarea"
          placeholder="请输入回告内容"
          v-model="textareaValue"
          resize="none"
        >
        </el-input>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitEmsAction()">发 送</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { chatSave, huiGaoList } from '../../api/index.js'
import { trim } from '../../utils/tools'
export default {
  data() {
    return {
      chatArr: [],
      textareaValue: '',
    }
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    dialogInfo: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    dialogVisibleHuiGao: {
      get() {
        return this.visible
      },
      set(val) {
        // 当visible改变的时候，触发父组件的 updateVisible方法，在该方法中更改传入子组件的 centerDialogVisible的值
        this.$emit('updateVisible', val)
      },
    },
  },
  watch: {
    dialogInfo: {
      //深度监听，可监听到对象、数组的变化
      handler(val, oldVal) {
        this.loadHuiGaoList(this.dialogInfo.platformId)
      },
      deep: true, //true 深度监听
    },
  },
  created() {},
  methods: {
    handleClose() {
      this.dialogVisibleHuiGao = false
    },
    loadHuiGaoList(platformId) {
      huiGaoList({ platformId: platformId }).then((res) => {
        if (res.status == 0) {
          this.chatArr = res.data
          //执行滚动到底部的逻辑
          this.$nextTick(() => {
            //必须使用nextTick（在下次 DOM 更新循环结束之后执行延迟回调）
            var divDom = this.$refs.divDom
            divDom.scrollTop = divDom.scrollHeight
          })
        }
      })
    },
    submitEmsAction() {
      if (trim(this.textareaValue) == '') {
        this.$message.error('发送内容不能为空')
        return
      }
      let dataPost = {
        platformId: this.dialogInfo.platformId,
        content: this.textareaValue,
      }
      chatSave(dataPost).then((res) => {
        if (res.status == 0) {
          this.textareaValue = ''
          this.$message.success('发送成功')
          this.loadHuiGaoList(this.dialogInfo.platformId)
        }
      })
    },
  },
}
</script>

<style scoped>
.rightchat{
  text-align: right;
}
.huigaodialogdiv /deep/.el-dialog__header {
  padding: 0px !important;  
}
.chatName {
  display: inline-block;
  vertical-align: top;
}
.chatTime {
  margin-bottom: 10px;
}
.chatContent {
  display: inline-block;
  margin-left: 10px;
  width: 800px;
}
.even {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #2a6cda;
}
.odd {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #00b472;
}
.textareacss /deep/.el-textarea__inner {
  height: 100px;
  background: #ecf2fe;
  border-radius: 4px;
}
.chatli {
  margin-bottom: 15px;
}
.listul {
  height: 300px;
  background: #ecf2fe;
  border-radius: 4px;
  list-style: none;
  padding: 10px 20px;
  overflow-y: auto;
}
.historyHuigao {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  margin: 20px 0;
}
.labeltext {
  margin-right: 20px;
}
.flexdiv {
  flex: 1;
}
.lianxidiv {
  display: flex;
  
}
.imgtop {
  margin-top: 3px;
}
.lineHeight * {
  vertical-align: middle;
}
.blueColorText {
  color: #0082f0;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  margin-left: 10px;
}
.bottonLine {
  margin: 12px 0;
}
</style>